import { BLOCKS } from '@contentful/rich-text-types';
import { List, ListItem, Typography } from '@mui/material';

export const options = {
    renderNode: {
        [BLOCKS.PARAGRAPH]: (node, children) =>
            <Typography variant='body1' gutterBottom>
                {children}
            </Typography>,
        [BLOCKS.HEADING_1]: (node, children) => (
            <Typography align="center" variant='h1' gutterBottom>
                {children}
            </Typography>
        ),
        [BLOCKS.HEADING_2]: (node, children) => (
            <Typography align="center" variant='h2' gutterBottom>
                {children}
            </Typography>
        ),
        [BLOCKS.HEADING_3]: (node, children) => (
            <Typography align="center" variant='h3' gutterBottom>
                {children}
            </Typography>
        ),
        [BLOCKS.HEADING_4]: (node, children) => (
            <Typography align="center" variant='h4' gutterBottom>
                {children}
            </Typography>
        ),
        [BLOCKS.HEADING_5]: (node, children) => (
            <Typography align="center" variant='h5' gutterBottom>
                {children}
            </Typography>
        ),
        [BLOCKS.HEADING_6]: (node, children) => (
            <Typography align="center" variant='h6' gutterBottom>
                {children}
            </Typography>
        ),
        [BLOCKS.OL_LIST]: (node, children) => (
            <List>
                {children}
            </List>
        ),
        [BLOCKS.UL_LIST]: (node, children) => (
            <List>
                {children}
            </List>
        ),
        [BLOCKS.LIST_ITEM]: (node, children) => (
            <ListItem>
                {children}
            </ListItem>
        )
    },
};